import { Controller } from "@hotwired/stimulus"

// This controller handles contact-sales button clicks
// It checks for other #contact-sales elements on the page and clicks them if found
// Otherwise, it navigates to the enterprise plan page

export default class extends Controller {
  static get values() {
    return {
      fallbackUrl: String,
    }
  }

  click() {
    // Find the #contact-sales button on the page (should only be 1 since phantom has different id)
    const contactSalesButton = document.querySelector("#contact-sales")

    if (contactSalesButton) {
      // If the button is found, click it
      contactSalesButton.click()
    } else if (this.fallbackUrlValue) {
      // If no button found, navigate to fallback URL
      Turbo.visit(this.fallbackUrlValue)
    }
  }
}
